import {GrayStatus, SuccessSVG, SuccessStatusSVG, UnSuccessSVG} from "assets";
import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import "./CancelPay.scss";
import {formatToCurrencyType} from "helper/common";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";

const columnsCancelPay: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "40px",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "content",
    key: "content",
    // width: '12%',
    align: "left",
  },
  {
    title: "BH",
    dataIndex: "bh",
    key: "bh",
    width: "40px",
    align: "center",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Có";
      } 
      else if (text == 1) {
        textTT = "Không";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
  },
  {
    title: "Đơn giá BV",
    dataIndex: "donGiaBenhVien",
    key: "donGiaBenhVien",
    // width: "18%",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
    align: "right",
  },
  {
    title: "Đơn giá BH",
    dataIndex: "donGiaBaoHiem",
    key: "donGiaBaoHiem",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
    align: "right",
  },
  {
    title: "SL",
    dataIndex: "soLuong",
    key: "soLuong",
    width: "40px",
    align: "right",
  },
  {
    title: "Thành tiền",
    dataIndex: "money",
    key: "money",
    editable: true,
    // width: '10%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Ngày chỉ định",
    dataIndex: "ngayChiDinh",
    key: "ngayChiDinh",
    align: "center",
    // width: '15%'
  },
  {
    title: "Thời gian thanh toán",
    dataIndex: "thoiGianTT",
    key: "thoiGianTT",
    align: "center",
    // width: '15%',
  },
  {
    title: "Tên thu ngân",
    dataIndex: "nguoiThanhToan",
    key: "nguoiThanhToan",
    // width: '15%'
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    width: "10%",
    render: text => {
      let textTT;
      if (text == 1) {
        textTT = "Đã thanh toán";
      } 
      else if (text == 2) {
        textTT = "Chưa thanh toán";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
  },
  // {
  //   title: "Lý do huỷ",
  //   dataIndex: "reason",
  //   key: "reason",
  //   // width: '10%',
  //   align: "left",
  // },
  {
    title: "TG huỷ",
    dataIndex: "timeCancel",
    key: "timeCancel",
    align: "center",
    // width: '10%'
  },
  {
    title: "Người huỷ",
    dataIndex: "nguoiHuy",
    key: "nguoiHuy",
    // width: '10%',
    align: "left",
  },
];

export {columnsCancelPay};
